import { FunctionResult as _FunctionResult } from "./useSpaceFunction";
export { default } from "./useSpaceFunction";

export type FunctionResult = _FunctionResult;
